import { toDateString } from "./dates"

export interface SampleTask {
  title: string
  description: string
}

export const sampleTasks: SampleTask[] = [
  {
    title: "Defeat the dirty dish army",
    description:
      "Launch a strategic assault on the pile of dishes using my trusty dishwasher ally",
  },
  {
    title: "Plan epic weekend adventure",
    description:
      "Channel my inner travel agent and discover the perfect getaway spot (that won't break the bank)",
  },
  {
    title: "Tame the quarterly report beast",
    description:
      "Wrangle those wild spreadsheets and charts into a presentation that actually makes sense",
  },
  {
    title: "Ring the mom hotline",
    description:
      "Check in with my favorite family news correspondent and get the latest gossip",
  },
  {
    title: "Silence the drip monster",
    description:
      "Show that leaky kitchen faucet who's boss by replacing its tiny washer heart",
  },
  {
    title: "Feed my brain 30 pages",
    description:
      "Continue my literary journey and pretend I'm making progress on my reading goals",
  },
  {
    title: "Excavate the desk archaeological site",
    description:
      "Unearth mysterious papers and discover what treasures lie beneath the clutter",
  },
  {
    title: "Embark on grocery quest",
    description:
      "Venture forth to gather sustenance and hopefully remember why I wrote 'bananas' on my list",
  },
  {
    title: "Face the dental music",
    description:
      "Book that long-overdue appointment and promise to floss more than just the night before",
  },
  {
    title: "Become a kitchen wizard",
    description:
      "Attempt to recreate that Thai curry magic without setting off the smoke alarm",
  },
  {
    title: "Polish my professional portrait",
    description:
      "Update my resume and try to make 'binge-watched Netflix' sound career-relevant",
  },
  {
    title: "Conquer the garage wilderness",
    description:
      "Navigate through the mysterious storage ecosystem and maybe find my bike again",
  },
  {
    title: "Spread gratitude like confetti",
    description:
      "Write heartfelt thank you notes to my amazing colleagues (and find stamps from this century)",
  },
  {
    title: "Start my herb empire",
    description:
      "Transform my windowsill into a tiny green kingdom of basil, oregano, and thyme",
  },
  {
    title: "Rescue my digital memories",
    description:
      "Save my precious files from the computer chaos before they disappear into the digital void",
  },
]

/**
 * Get a sample task based on today's date for consistent daily placeholders
 */
export const getTodaysSampleTask = (): SampleTask => {
  const today = new Date()
  const dateString = toDateString(today)

  // Convert date string to a number for consistent hashing
  const hash = dateString
    .split("")
    .reduce((acc, char) => acc + char.charCodeAt(0), 0)

  const index = hash % sampleTasks.length
  return sampleTasks[index]
}

/**
 * Generate a random string of the specified length using alphanumeric characters
 */
export const generateRandomString = (length: number = 8): string => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
  let result = ""
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length))
  }
  return result
}
